import * as api from '@app/api.js'

export default {
  methods: { ...api },
}
